import * as api from '../../constants/api'
import callApi from '../http'

const operatorLogin = async (body) => await callApi(api.LOGIN, body)

const userLogout = async (body) => await callApi(api.AUTH_LOGOUT, body)

const forgotPassword = async (body) => await callApi(api.FORGOT_PASSWORD, body)

const getAuthTokenUser = async (body) => await callApi(api.AUTH_TOKEN_USER, body)

const operatorGetProfile = async (body) => await callApi(api.OPERATOR_PROFILE, body)

const operatorUpdateOnline = async (body) => await callApi(api.OPERATOR_UPDATE_ONLINE, body)


export {
    userLogout,
    operatorLogin,
    forgotPassword,
    getAuthTokenUser,
    operatorGetProfile,
    operatorUpdateOnline,
}